import React from "react";
import { Link } from "react-router-dom";
import _ from "underscore";
import Corpo from "../components/Corpo";
import { useWebsocket } from "../hooks/websocket";
import * as desafioService from "../services/desafio";
//import { updateUser } from "../services/user";
import { finishMatchMultiplayer } from "../services/match-service";

export default function TabMultiFim(props) {
  const [message, setMessage] = React.useState("");
  const [me, setMe] = React.useState({});
  const [theme, setTheme] = React.useState();
  const [winner, setWinner] = React.useState(false);
  const [opponent, setOpponent] = React.useState({});
  const [currentCategoryId, setCurrentCategoryId] = React.useState(0);
  const { stompClient } = useWebsocket();

  let getResults = (results) => {
    let wins = 0,
      timingsSum = 0;

    _.each(results, function (result) {
      if (result.matchAnswerResult === 1) {
        wins += 1;
      }
      timingsSum += result.matchAnswerTime;
    });

    return [wins, timingsSum];
  };

  const playWithSameOpponent = React.useCallback(() => {
    if (opponent && opponent.id) {
      stompClient.publish({
        destination: "/app/invite-user",
        body: JSON.stringify({
          ...opponent,
          userId: opponent.id,
          themeName: theme?.nome,
          challengerId: window.GLOBALS.user.info.id,
          challengerName: window.GLOBALS.user.info.nome,
          challengerMatchPoints: window.GLOBALS.user.info.qtdPontos,
        }),
      });
    }
  }, [opponent, stompClient, theme]);

  React.useEffect(() => {
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    let localMe, localOpponent;

    if ( window.GLOBALS.actualMultiplayerMatch.info?.opponent.id.toString() === window.GLOBALS.user.info.id.toString() ) {
      localMe = _.clone(window.GLOBALS.actualMultiplayerMatch.info?.opponent);
      setMe(localMe);

      localOpponent = _.clone(window.GLOBALS.actualMultiplayerMatch.info?.challenger);
      setOpponent(localOpponent);
    } else {
      localMe = _.clone(window.GLOBALS.actualMultiplayerMatch.info?.challenger);
      setMe(localMe);

      localOpponent = _.clone(window.GLOBALS.actualMultiplayerMatch.info?.opponent);
      setOpponent(localOpponent);
    }

    // migration refactoring - start
    let currentUser;
    let opponentUser;
    let winningUser;
    let qtdPointsCurrentUser;
    let qtdPointsOpponentUser;

    currentUser = localMe;
    opponentUser = localOpponent;
    // migration refactoring - end


    let newMe = _.clone(localMe);

    if (newMe !== undefined) {
      newMe.wins = 0;
      newMe.timingsSum = 0;
      setMe(newMe);
    }

    // Socket a ser desafiado
    let newOpponent = _.clone(localOpponent);
    newOpponent.encodedSocket = encodeURIComponent(
      localOpponent.socket?.substr(2)
    );
    setOpponent(newOpponent);

    window.GLOBALS.categoriasArray.forEach((category) => {
      category.listaTemas.forEach((theme) => {
        if (
          theme.nome === window.GLOBALS.actualMultiplayerMatch.info.themeName
        ) {
          setCurrentCategoryId(category.id);
          setTheme(theme);
          return;
        }
      });
    });

    // Meu resultado
    let myStat = getResults(localMe.results);
    newMe = _.clone(localMe);
    newMe.resultsEnd = myStat[0];
    setMe(newMe);

    // Resultado do oponente
    let oponentStat = getResults(localOpponent.results);
    newOpponent = _.clone(localOpponent);
    newOpponent.resultsEnd = oponentStat[0];
    setOpponent(newOpponent);

    // migration refactoring - start
    qtdPointsCurrentUser = myStat[0];
    qtdPointsOpponentUser = oponentStat[0];
    // migration refactoring - end

    // Caso eu tenha mais vitórias
    if (myStat[0] > oponentStat[0]) {
      setMessage("Você venceu!");
      setWinner(true);
      window.GLOBALS.user.info.qtdPontos = localMe.matchPoints + 30;
      
      // migration refactoring - start
      winningUser = currentUser;
      qtdPointsCurrentUser = qtdPointsCurrentUser + 30;
      // migration refactoring - end
    } else {
      if (myStat[0] === oponentStat[0]) {
        // Desempate no tempo
        if (myStat[1] >= oponentStat[1]) {
          setMessage("Você venceu pois respondeu as perguntas em menos tempo!");
          setWinner(true);
          window.GLOBALS.user.info.qtdPontos = localMe.matchPoints + 30;

          // migration refactoring - start
          winningUser = currentUser;
          qtdPointsCurrentUser = qtdPointsCurrentUser + 30;
          // migration refactoring - end
        } else {
          setMessage("Você perdeu pois demorou mais tempo para responder as perguntas!");
          setWinner(false);
          window.GLOBALS.user.info.qtdPontos = localMe.matchPoints;
          
          // migration refactoring - start
          winningUser = opponentUser;
          qtdPointsOpponentUser = qtdPointsOpponentUser + 30;
          // migration refactoring - end
        }
      } else {
        setMessage("Você perdeu!");
        setWinner(false);
        window.GLOBALS.user.info.qtdPontos = localMe.matchPoints;

        // migration refactoring - start
        winningUser = opponentUser;
        qtdPointsOpponentUser = qtdPointsOpponentUser + 30;
        // migration refactoring - end
      }
    }

    // migration refactoring - start
    let match = {
      idTema: window.GLOBALS.actualMultiplayerMatch.themeId,
      idUsuarioVencedor: winningUser.id
    };

    if ( window.GLOBALS.actualMultiplayerMatch.guestUserId.toString() === window.GLOBALS.user.info.id.toString() ) {
      match.idUsuarioConvidado = currentUser.id;
      match.qtdPontosConvidado = qtdPointsCurrentUser;
      match.idUsuarioDesafiado = opponentUser.id;
      match.qtdPontosDesafiado = qtdPointsOpponentUser;
    }
    else {
      match.idUsuarioConvidado = opponentUser.id;
      match.qtdPontosConvidado = qtdPointsOpponentUser;
      match.idUsuarioDesafiado = currentUser.id;
      match.qtdPontosDesafiado = qtdPointsCurrentUser;
    }

    finishMatchMultiplayer(match)
    .then((res) => {
      console.error("finishMatchMultiplayer.success: ", res.data);
    })
    .catch((error) => {
      console.error("finishMatchMultiplayer.error: ", error);
    });
    // migration refactoring - end

    window.GLOBALS.isInMultiplayer = false;

    // updateUser(window.GLOBALS.user.info);

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  }, []);

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div
          className="view-jogo jogo-multi fim pane-game"
          style={{ height: "100%" }}
        >
          <div className="placar-final">
            <h2
              className="title"
              style={{
                margin: "0",
                paddingTop: "100px",
                paddingBottom: "30px",
              }}
            >
              Partida Encerrada
              <span>{message}</span>
            </h2>
            <div className={winner ? "users" : "users lost"}>
              <div className="user left">
                <div>
                  <span className="name">
                    {decodeURIComponent(me?.name?.split(" ")[0])}
                  </span>
                  <div>
                    <img
                      src={desafioService.checkImg(me?.picture)}
                      className="user-image"
                      alt=""
                    />
                    <span className="user-text">{me?.resultsEnd}</span>
                  </div>
                </div>
              </div>
              <div className="user right">
                <div>
                  <span className="name">
                    {decodeURIComponent(opponent?.name?.split(" ")[0])}
                  </span>
                  <div>
                    <img
                      src={desafioService.checkImg(opponent?.picture)}
                      className="user-image"
                      alt=""
                    />
                    <span className="user-text">{opponent?.resultsEnd}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="desafio-footer">
            <Link
              to={"/tab/multi/" + currentCategoryId + "/" + theme?.id}
              onClick={() => playWithSameOpponent()}
              className="button button-full button-lg-slim"
            >
              Jogar com o mesmo adversário
            </Link>
            <Link
              to={"/tab/multi/" + currentCategoryId + "/" + theme?.id}
              className="button button-full button-lg-slim"
            >
              Jogar com outro adversário
            </Link>
            <Link to="/tab/jogo" className="button button-full button-lg-slim">
              Sair do jogo
            </Link>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
